import React, { useMemo } from "react";

import Banner0 from "./Banner0";
import Content0 from "./Content0";
import ProductGrid from "./ProductGrid";
import Cwp from "./Cwp";
import BlogGrid from "./BlogGrid";
import { useDocumentMeta, useI18n } from "../i18n";
import { getPageData } from "./pageData";

export default function Home() {
  const { t } = useI18n();
  const page = useMemo(() => getPageData(t), [t]);

  useDocumentMeta({
    title: t.meta.title,
    description: t.meta.description,
    path: "/",
  });

  return (
    <main>
      <Banner0 dataSource={page.banner} />
      <ProductGrid dataSource={page.products} />
      <Cwp dataSource={page.bdf} />
      <Cwp dataSource={page.cxl} />
      <Cwp dataSource={page.cwp} />
      <Content0 dataSource={page.cwpUse} />
      <Cwp dataSource={page.token} />
      <Cwp dataSource={page.firmware} />
      <BlogGrid />
    </main>
  );
}
